<template>
  <div class="service-aux-alarm">
    <p>
      {{ $t('messages.alarms.serviceAUXAlarm.description') }}
    </p>

    <alarm-status
      :alarm="alarm"
      :alarm-active="computedAlarmIsActive"
    />

    <!-- <div class="g-alarm-handler__row">
      <h3>{{ $t('messages.alarms.suggestion') }}</h3>
      <p>
        {{ $t('messages.alarms.serviceAUXAlarm.suggestion') }}
      </p>
    </div> -->
  </div>
</template>

<script>
import {ServiceAlarm} from '@/assets/javascript/mixins/ServiceAlarm'

export default {
  name: 'ServiceAuxAlarm',
  mixins: [ServiceAlarm]
}
</script>
